import { render, staticRenderFns } from "./cbhy.vue?vue&type=template&id=5fb3c411&scoped=true"
import script from "./cbhy.vue?vue&type=script&lang=js"
export * from "./cbhy.vue?vue&type=script&lang=js"
import style0 from "./cbhy.vue?vue&type=style&index=0&id=5fb3c411&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb3c411",
  null
  
)

export default component.exports